import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-8 md:py-12 px-6 bg-[#FFF0F3]" data-id="element-186">
      <div className="max-w-4xl mx-auto" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-pink-100 flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-188">
          <div className="flex-1 w-full relative" data-id="element-189">
            <div className="absolute -top-4 -left-4 bg-[#C41E3A] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-full shadow-lg -rotate-3 z-10" data-id="element-190">
              Oferta por Lanzamiento
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/cBSMPU4vmAjJtUkxETdg6a/mockup_-_Desconexion_Emocional_en_dispositivos_digitales.png" alt="Mockup Desconexión Emocional" className="w-full h-auto drop-shadow-xl" data-id="element-191" />
          </div>

          <div className="flex-1 w-full text-center md:text-left" data-id="element-192">
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-warmBrown mb-4" data-id="element-193">
              ¡Accede Hoy a Tu Guía!
            </h2>

            <div className="flex items-center justify-center md:justify-start gap-4 mb-6" data-id="element-194">
              <span className="text-2xl text-gray-400 line-through font-medium" data-id="element-195">
                $19.99
              </span>
              <span className="text-5xl font-bold text-[#C41E3A]" data-id="element-196">
                $4.99 <span className="text-xl" data-id="element-197">USD</span>
              </span>
            </div>

            <div className="mb-8 text-left" data-id="element-198">
              <p className="font-bold text-warmBrown mb-4" data-id="element-199">Incluye:</p>
              <ul className="space-y-3 text-mutedBrown list-disc list-inside marker:text-terracotta" data-id="element-200">
                <li data-id="element-201">comprensión del problema,</li>
                <li data-id="element-202">validación emocional,</li>
                <li data-id="element-203">orden mental,</li>
                <li data-id="element-204">claridad para decidir,</li>
                <li data-id="element-205">y una ruta privada para dejar de sufrir en silencio.</li>
              </ul>
            </div>

            <CTAButton text="QUIERO ACCEDER AHORA" icon={<ZapIcon className="w-5 h-5" data-id="element-207" />} href="https://pay.hotmart.com/E104809825H" data-id="element-206" />
          </div>
        </motion.div>
      </div>
    </section>;
}